export default {"src":"/_next/static/media/Galileo_Logo.1f5bcb73.svg","height":24,"width":110,"blurWidth":0,"blurHeight":0};